var path = '/formViewer/component/urlLink/urlLinkPlaceholder.tpl.html';
var html = "<ui-url-link class=\"fieldListComponent\"\n             field-structure=\"fieldStructure\"\n             collapsible=\"::$ctrl.collapsible\"\n             ui-show-field-details-modal></ui-url-link>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;